const mobile = 480
const tablet = 768

export { mobile, tablet }
